import type { RequestInterface } from '~/common/types';
import { CorrectiveActionForm } from '~/correctiveActions/types';

export class CorrectiveActionsRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/corrective-actions';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class CorrectiveActionsStatsRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/corrective-actions-stats';
  headers: Record<string, any>;

  constructor({ token }: { token: string }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
  }
}

export class GetCorrectiveActionRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    correctiveActionId,
    params,
  }: {
    token: string;
    correctiveActionId: string;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/corrective-actions/${correctiveActionId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class ViewSubmittedFormPdfRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;

  constructor({
    token,
    submittedFormID,
  }: {
    token: string;
    submittedFormID: string;
  }) {
    this.path = `/api/v1/submitted-forms/${submittedFormID}/view`;
    this.headers = { authorization: `Bearer ${token}` };
  }
}

export class DownloadSubmittedFormPdfRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;

  constructor({
    token,
    submittedFormID,
  }: {
    token: string;
    submittedFormID: string;
  }) {
    this.path = `/api/v1/submitted-forms/${submittedFormID}/download`;
    this.headers = { authorization: `Bearer ${token}` };
  }
}

export class UpdateCorrectiveActionRequest implements RequestInterface {
  method = 'patch';
  path: string;
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({
    token,
    correctiveActionId,
    correctiveAction,
  }: {
    token: string;
    correctiveActionId: string;
    correctiveAction: CorrectiveActionForm;
  }) {
    this.path = `/api/v1/corrective-actions/${correctiveActionId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...correctiveAction,
    };
  }
}
